(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Application.Terminate",
        {
            url: "/Terminate",
            component: "applicationTermination",
            resolve: {
                transaction: [
                    "transactionApi", "$stateParams", function (transactionApi, $stateParams) {
                        return transactionApi.get($stateParams.transactionId);
                    }
                ],
                inforce: ["transaction", "inforceTransactionApi", function (transaction, inforceTransactionApi) {
                    return inforceTransactionApi.get(transaction.Id).catch(ng.noop);
                }]
            },
            onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                transaction.LastTransactionStage = "Terminate";
                return transactionApi.updateLastTransactionStage(transaction.Id, transaction);
            }]
        });
    }]);

    app.component("applicationTermination",
    {
        templateUrl: "/App/Transaction/Application/Terminate/template.html",
        controller: applicationTerminationController,
        bindings: {
            transaction: "<",
            inforce: "<"
        }
    });

    applicationTerminationController.$inject = ["$state", "transactionApi", "$mdDialog"];

    function applicationTerminationController($state, transactionApi, $mdDialog) {
        this.$state = $state;
        var $ctrl = this;
        //$scope.$parent.$ctrl.getCurrentStage($state);

        ng.extend($ctrl,
        {
            exitDialog: exitDialog,
            closeDialog: closeDialog,
            termTransaction: termTransaction
        });

        function exitDialog($event) {
            var exit = $mdDialog.show({
                contentElement: "#myDialog",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };

        function closeDialog() {
            $mdDialog.hide();
        }
        
        function termTransaction() {
            $ctrl.transaction.TransactionStatus = "PaperApplication";
            transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                $state.go("Home.ViewTransactions");
            });
        }

    }

})(window.app, window.angular);